export const MIN_MEMBER = 200;
